import type { ReactNode } from "react";

/** Shared task surface for buyer flow steps. */
export function FlowStepPhoneFrame({
  children,
  testId
}: {
  children: ReactNode;
  testId?: string;
}) {
  return (
    <div
      className="mx-auto w-full"
      data-testid={testId}
    >
      <div className="panel overflow-hidden bg-white">{children}</div>
    </div>
  );
}

export function FlowStepAside(_props: {
  label: string;
  title: string;
  body: string;
}) {
  return null;
}

export function FlowStepLayout({
  phone
}: {
  aside: ReactNode;
  phone: ReactNode;
}) {
  return (
    <div className="grid min-w-0">
      <div className="min-w-0">{phone}</div>
    </div>
  );
}
